import {getWindowWidth} from '../util/helperFunctions';

const body = document.body;
const siteHeader = document.getElementById('site-header');
const siteNavbarCollapse = document.getElementById('navigation');
const siteNavbarToggler = document.querySelector('.navbar-toggler-alternative');
const isHeaderDefaultDark = siteHeader.classList.contains('navbar-dark')
	? true
	: false;

// Scroll
const handleScroll = () => {
	if (window.scrollY > 0) {
		body.classList.add('is-scrolling');

		if (isHeaderDefaultDark) {
			siteHeader.classList.remove('navbar-dark');
			siteHeader.classList.add('navbar-light');
		}
	} else {
		body.classList.remove('is-scrolling');

		if (isHeaderDefaultDark) {
			siteHeader.classList.remove('navbar-light');
			siteHeader.classList.add('navbar-dark');
		}
	}
};

window.addEventListener('scroll', handleScroll);

// Navigation collapse
if (siteNavbarCollapse) {
	siteNavbarCollapse.addEventListener('show.bs.collapse', () => {
		body.classList.add('site-header-toggled-show');

		if (isHeaderDefaultDark) {
			siteHeader.classList.remove('navbar-dark');
			siteHeader.classList.add('navbar-light');
		}
	});

	siteNavbarCollapse.addEventListener('hidden.bs.collapse', () => {
		body.classList.remove('site-header-toggled-show');

		if (isHeaderDefaultDark) {
			siteHeader.classList.remove('navbar-light');
			siteHeader.classList.add('navbar-dark');
		}
	});
}

// Close nav on click outside of '.sitenav-collapse-inner'
const navbarAutoClose = (e) => {
	const target = e.target;

	if (
		target.matches('.site-header') ||
		(target.closest('.site-header') &&
			target.closest('.site-header').classList.contains('site-header')) ||
		target.classList.contains('navbar-toggler') ||
		target.classList.contains('navbar-toggler-alternative')
	) {
		return;
	}

	if (
		siteNavbarToggler.hasAttribute('aria-expanded') &&
		siteNavbarToggler.getAttribute('aria-expanded') === 'true'
	) {
		siteNavbarToggler.click();
	}
};

document.addEventListener('click', navbarAutoClose);
document.addEventListener('touchstart', navbarAutoClose);

// Resize
let resizing;

window.addEventListener('resize', () => {
	clearTimeout(resizing);

	resizing = setTimeout(() => {
		if (getWindowWidth() >= 992) {
			if (
				siteNavbarToggler.hasAttribute('aria-expanded') &&
				siteNavbarToggler.getAttribute('aria-expanded') === 'true'
			) {
				body.classList.remove('site-header-toggled-show');
				siteNavbarCollapse.classList.remove('show');
				siteNavbarToggler.setAttribute('aria-expanded', 'false');
			}
		} else {
			body.classList.remove('is-header-hidden');
		}
	}, 100);
});
